import { atom } from "recoil"

export const migrationIdState = atom<string | undefined>({
  key: "atoms/contact/create/migrationIdState",
  default: undefined,
})
